module.exports = __webpack_public_path__ + "media/images/gls-11ef673a.svg";